import { EventEmitter } from 'events';

export const API_EVENT_EMITTER = new EventEmitter();
